import { c as _c } from "react/compiler-runtime";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import ApprovalDropVoteSummary from "@/components/waves/drops/ApprovalDropVoteSummary";
import { getThemeColors } from "./ParticipationDropRatingsTheme";
import type { RatingsData } from "./types";
import ParticipationDropRatingsTotalSection from "./ParticipationDropRatingsTotalSection";
import ParticipationDropRatingsVoterSection from "./ParticipationDropRatingsVoterSection";
import ParticipationDropRatingsUserSection from "./ParticipationDropRatingsUserSection";
interface ParticipationDropRatingsContainerProps {
  readonly drop: ApiDrop;
  readonly rank?: number | null | undefined;
  readonly winningThreshold?: number | null | undefined;
  readonly winningThresholdMinDurationMs?: number | null | undefined;
  readonly isVotingClosed?: boolean | undefined;
}
export default function ParticipationDropRatingsContainer(t0) {
  const $ = _c(36);
  const {
    drop,
    rank: t1,
    winningThreshold,
    winningThresholdMinDurationMs,
    isVotingClosed: t2
  } = t0;
  const rank = t1 === undefined ? null : t1;
  const isVotingClosed = t2 === undefined ? false : t2;
  const isApprovalSummary = typeof winningThreshold === "number" && Number.isFinite(winningThreshold) && winningThreshold > 0;
  if (isApprovalSummary) {
    let t3;
    if ($[0] !== drop || $[1] !== isVotingClosed || $[2] !== winningThreshold || $[3] !== winningThresholdMinDurationMs) {
      t3 = <ApprovalDropVoteSummary drop={drop} winningThreshold={winningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} variant="chat" />;
      $[0] = drop;
      $[1] = isVotingClosed;
      $[2] = winningThreshold;
      $[3] = winningThresholdMinDurationMs;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  const t3 = drop.top_raters.length > 0;
  const t4 = drop.context_profile_context?.rating ?? 0;
  let t5;
  if ($[5] !== drop.rating || $[6] !== t3 || $[7] !== t4) {
    t5 = {
      hasRaters: t3,
      userRating: t4,
      currentRating: drop.rating
    };
    $[5] = drop.rating;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const ratingsData = t5;
  const t6 = ratingsData.currentRating < 0;
  let t7;
  if ($[9] !== rank || $[10] !== t6) {
    t7 = getThemeColors(rank, t6);
    $[9] = rank;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const theme = t7;
  let t8;
  if ($[12] !== drop || $[13] !== isVotingClosed || $[14] !== rank || $[15] !== ratingsData || $[16] !== theme || $[17] !== winningThreshold || $[18] !== winningThresholdMinDurationMs) {
    t8 = <ParticipationDropRatingsTotalSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} winningThreshold={winningThreshold} winningThresholdMinDurationMs={winningThresholdMinDurationMs} isVotingClosed={isVotingClosed} />;
    $[12] = drop;
    $[13] = isVotingClosed;
    $[14] = rank;
    $[15] = ratingsData;
    $[16] = theme;
    $[17] = winningThreshold;
    $[18] = winningThresholdMinDurationMs;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== drop || $[21] !== rank || $[22] !== ratingsData || $[23] !== theme) {
    t9 = <ParticipationDropRatingsVoterSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} />;
    $[20] = drop;
    $[21] = rank;
    $[22] = ratingsData;
    $[23] = theme;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  let t10;
  if ($[25] !== t8 || $[26] !== t9) {
    t10 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2">{t8}{t9}</div>;
    $[25] = t8;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== drop || $[29] !== rank || $[30] !== ratingsData || $[31] !== theme) {
    t11 = <ParticipationDropRatingsUserSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} />;
    $[28] = drop;
    $[29] = rank;
    $[30] = ratingsData;
    $[31] = theme;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== t10 || $[34] !== t11) {
    t12 = <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-4 tw-gap-y-2">{t10}{t11}</div>;
    $[33] = t10;
    $[34] = t11;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
}